import Bar from '../../../../components/elements/Bar';
import { Pencil } from 'lucide-react';
import List from '../../../../components/elements/List';
import { usePermission } from '../../../../hooks/usePermission';
import ApprovalItemActions from '../../../approval/components/ApprovalItemActions';

const TechnicalReportItemSetView = ({ data, onEdit }) => {
  const { isEditable } = usePermission();
  const prepareData = () => {
    if (!data) return [];
    return [{ name: 'Název', value: data.title }];
  };

  return (
    <div>
      <Bar
        text="Detail"
        content={
          isEditable
            ? [
                <Pencil
                  key={1}
                  className="h-4 w-4"
                  onClick={onEdit}
                  data-testid="tech-report-item-set-view-edit-btn"
                />,
              ]
            : []
        }
      />
      <ApprovalItemActions
        objectType="settechnicalreportitem"
        objectId={data?.id}
        status={data?.status}
      />
      <List data={prepareData()} />
      <div className="mb-px">
        <Bar text="Položky technické zprávy" />
        <List
          data={(data?.technical_report_item_set || []).map((technical_report_item) => ({
            name: technical_report_item.description,
          }))}
        />
      </div>
    </div>
  );
};

export default TechnicalReportItemSetView;
